import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        // 重定向
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            name: 'Home',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/home`),
            meta: {
                title: ''
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/login`),
            meta: {
                title: ''
            }
        },
        {
            path: '/career',
            name: 'Career',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/career`),
            meta: {
                title: ''
            }
        },
        {
            path: '/apply',
            name: 'Apply',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/apply`),
            meta: {
                title: ''
            }
        },
        {
            path: '/weeklyUpdates',
            name: 'weeklyUpdates',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/weeklyUpdates`),
            meta: {
                title: ''
            }
        },
        {
            path: '/aboutTheAssociation',
            name: 'aboutTheAssociation',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/aboutTheAssociation`),
            meta: {
                title: '关于协会'
            }
        },
        {
            path: '/joinTheAssociation',
            name: 'joinTheAssociation',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/joinTheAssociation`),
            meta: {
                title: '加入协会'
            }
        },
        {
            path: '/informationCenter',
            name: 'informationCenter',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/informationCenter`),
            meta: {
                title: '资讯中心'
            }
        },
        {
            path: '/associationActivities',
            name: 'associationActivities',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/associationActivities`),
            meta: {
                title: '协会活动'
            }
        },
        {
            path: '/detail',
            name: 'detail',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/detail`),
            meta: {
                title: '详情'
            }
        },
        {
            path: '/admin',
            name: 'Admin',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/admin`),
            meta: {
                title: ''
            }
        },
        {
            path: '/yqLink',
            name: 'yqLink',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/yqLink`),
            meta: {
                title: '友情链接'
            }
        },
        {
            path: '/careerList',
            name: 'careerList',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/careerList`),
            meta: {
                title: ''
            }
        },
        {
            path: '/practiceTest',
            name: 'practiceTest',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/practiceTest`),
            meta: {
                title: ''
            }
        },
        {
            path: '/search',
            name: 'search',
            component: () =>
                import ( /* webpackChunkName: "about" */ `../views/search`),
            meta: {
                title: ''
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js